import { Directive } from '@angular/core'
import { Validator, FormControl } from '@angular/forms'
import { NG_VALIDATORS } from '@angular/forms'

@Directive({
  selector: '[linAutocompleteFieldValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AutocompleteFieldValidator,
      multi: true,
    },
  ],
  standalone: false,
})
export class AutocompleteFieldValidator implements Validator {
  validate({ value }: FormControl) {
    const isNotValid = !value || !value?.id || value?.length
    return isNotValid ? { invalid: true } : null
  }
}
